import React from 'react';
import HeaderComponent from './HeaderComponent';

const HeaderContainer = (): JSX.Element => {
  return <HeaderComponent />;
};

export default HeaderContainer;
